import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> = [
    {
        path: '/content',
        component: () => import('@/views/Content/Index.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: false,
        }
    },
]

export default routes;